import { colors as e } from "./colors.js";
import { DEFAULT_PRIMARY_BRAND_COLOR as n, createColorDict as i, createColorScheme as p } from "./colors.js";
import { createCSSVariables as x } from "./utils/create-css-variables.js";
import { generateThemeVariables as g, themeMappings as d } from "./utils/generate-theme-variables.js";
const o = {
  heading: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  body: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
}, r = {
  "3xs": "0.45rem",
  "2xs": "0.625rem",
  xs: "0.75rem",
  "1sm": "0.8125rem",
  sm: "0.875rem",
  "2sm": "0.9375rem",
  md: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
  "7xl": "4.5rem",
  "8xl": "6rem",
  "9xl": "8rem"
}, m = {
  hide: -1,
  auto: "auto",
  base: 0,
  start: 1,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, l = {
  colors: e,
  fontFamily: o,
  fontSize: r,
  zIndex: m
};
export {
  n as DEFAULT_PRIMARY_BRAND_COLOR,
  e as colors,
  x as createCSSVariables,
  i as createColorDict,
  p as createColorScheme,
  g as generateThemeVariables,
  l as theme,
  d as themeMappings
};
